import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { XMarkIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import Button from "../buttons/button";
import { router } from "@inertiajs/react";
export default function EmailUnverifiedPrompt({
    buttonText,
}: {
    buttonText: string;
}) {
    const [open, setOpen] = useState(false);
    const [resent, setResent] = useState(false);
    return (
        <div>
            <Button
                color="voice"
                className="w-full justify-center"
                onClick={() => setOpen(true)}
            >
                <FormattedMessage id={buttonText} />
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                className="relative z-999"
            >
                <div
                    className="fixed inset-0 bg-gray-500/75"
                    aria-hidden="true"
                />
                <div className="fixed inset-0 flex w-screen items-center justify-center p-8">
                    <DialogPanel className="w-96 rounded-sm bg-white p-8">
                        <div className="flex items-center justify-between">
                            <DialogTitle className="text-3xl font-bold">
                                <FormattedMessage id="Verify your email" />
                            </DialogTitle>
                            <button
                                onClick={() => setOpen(false)}
                                className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                            >
                                <span className="sr-only">
                                    <FormattedMessage id="close" />
                                </span>
                                <XMarkIcon className="size-6" />
                            </button>
                        </div>
                        <div className="text-sm text-gray-900">
                            <p className="mt-2">
                                <FormattedMessage id="Before taking part in any Voice activity we require you to verify your email address." />
                            </p>
                            <p className="mt-2">
                                <FormattedMessage id="A verification email was sent to you when you registered to join Voice. If you missed it, please click resend below." />
                            </p>
                        </div>
                        <div className="mt-4">
                            {!resent ? (
                                <div className="flex space-x-2">
                                    <Button
                                        color="black"
                                        onClick={() => {
                                            router.post(
                                                route("verification.send"),
                                                undefined,
                                                {
                                                    onFinish: () =>
                                                        setResent(true),
                                                },
                                            );
                                        }}
                                    >
                                        <FormattedMessage id="Resend verification email" />
                                    </Button>
                                </div>
                            ) : (
                                <div className="border-l-4 border-gray-400 bg-gray-50 p-4">
                                    <div className="flex">
                                        <div className="shrink-0">
                                            <CheckCircleIcon className="size-5" />
                                        </div>
                                        <div className="ml-3 text-sm">
                                            <p className="text-gray-900 font-semibold">
                                                <FormattedMessage id="We've sent a new verification email." />
                                            </p>
                                            <p className="mt-2 text-gray-500">
                                                <FormattedMessage id="Remember to check your spam folder." />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </div>
    );
}
